<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Índices</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaIndice
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :lista-tipo-indice="dados.listaTipoIndice"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Índices Encontrados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Índices Selecionados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="incluir" :disabled="selecteds.length !== 1">
                                <i class="fa fa-plus"></i> Incluir Percentual Mensal
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-b-modal.modal-inativar :disabled="selecteds.length !== 1 || selecteds[0].situacao == 'Inativo'">
                                <i class="fas fa-edit"></i> Inativar
                            </b-button>
                            <b-button class="ml-2" variant="primary" @click="listarHistorico" :disabled="selecteds.length !== 1">
                                <i class="fas fa-eye"></i> Exibir
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <b-modal
                ref="modal-inativar"
                id="modal-inativar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Inativar Índice"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja inativar o índice selecionado?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-inativar')"> Voltar</b-button>
                <b-button variant="primary" @click="inativar"> Confirmar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-historico"
                id="modal-historico"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Descrição Índice"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-table
                            :items="dados.historico"
                            :fields="fieldsHistorico"
                            striped
                            small
                            responsive
                            :busy="false"
                            show-empty
                            hover
                            bordered
                            sort-icon-left
                            class="mb-0"
                            head-variant="light">
                        <div slot="table-busy" class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                        <template slot="empty">
                            <p class="my-auto">Nenhum percentual mensal encontrado.</p>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-historico')"> Voltar</b-button>
            </template>
        </b-modal>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaIndice from "./TabelaIndice";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {CompLoading, CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaIndice, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                ll: true,
                l2: true,
                urlApi: null,
                token: null,
                value: null,
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    },
                    {
                        key: "1",
                        nome: "1",
                    }
                ],
                dados: {
                    listaTipoIndice: null,
                    historico: null
                },
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'indice.descricao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    filtrarDescricao: null,
                    descricao: null,
                    tipos: [],
                    filtrarAtualizacao: null,
                    atualizacao: null,
                    filtrarUsuario: null,
                    usuario: null,
                    cumulatividade: null,
                    situacao: null
                },
                fieldsHistorico: [
                    {
                        key: 'mes',
                        sortable: true,
                        label: 'Mês.'
                    },
                    {
                        key: 'ano',
                        sortable: true,
                        label: 'Ano'
                    },
                    {
                        key: 'variacao',
                        sortable: true,
                        label: 'Variação Índice (%)'
                    }
                ]
            }
        },
        methods: {
            async listarTipoIndice() {
                axios.get(`${this.urlApi}/v1/indice/listarTipoIndice`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.listaTipoIndice = response.data;
                })
            },
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/indice/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'indice';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            incluir(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setIndice', this.selecteds[0]);
                    this.$router.push({path: '/indice/percentual'});
                }
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Descrição') {
                        this.filtro.filtrarEm = this.filtros.filtrarDescricao;
                        this.filtro.campoTexto = this.filtros.descricao;
                    } else if(this.filtro.campoFiltro == 'Tipo') {
                        this.filtro.campoCheckbox = this.filtros.tipos;
                    } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                        this.filtro.filtrarEm = this.filtros.filtrarAtualizacao;
                        this.filtro.campoData = this.filtros.atualizacao;
                    } else if(this.filtro.campoFiltro == 'Usuário da Última Alteração') {
                        this.filtro.filtrarEm = this.filtros.filtrarUsuario;
                        this.filtro.campoTexto = this.filtros.usuario;
                    } else if(this.filtro.campoFiltro == 'Cumulatividade do Índice') {
                        this.filtro.campoRadio = this.filtros.cumulatividade;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoRadio = this.filtros.situacao;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoMascara = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Descrição') {
                    this.filtros.filtrarDescricao = this.filtro.filtrarEm;
                    this.filtros.descricao = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Tipo') {
                    this.filtros.tipos = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.filtros.filtrarAtualizacao = this.filtro.filtrarEm;
                    this.filtros.atualizacao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Usuário da Última Alteração') {
                    this.filtros.filtrarUsuario = this.filtro.filtrarEm;
                    this.filtros.usuario = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Cumulatividade do Índice') {
                    this.filtros.cumulatividade = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoRadio;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Descrição') {
                    this.configTable.sortField = 'indice.descricao';
                } else if(this.filtro.campoFiltro == 'Tipo') {
                    this.configTable.sortField = 'indice.tipoIndice';
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.configTable.sortField = 'indice.dataHoraAlteracao';
                } else if(this.filtro.campoFiltro == 'Usuário da Última Alteração') {
                    this.configTable.sortField = 'usuario.nome';
                } else if(this.filtro.campoFiltro == 'Cumulatividade do Índice') {
                    this.configTable.sortField = 'indice.inacumulavel';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'indice.indAtivo';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },

            inativar() {
                this.$refs['modal-inativar'].hide();

                this.$refs.loading.showLoading();
                axios.put(`${this.urlApi}/v1/indice/inativar/${this.selecteds[0].codIndice}`, {}, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                    this.selecteds = [];
                    this.consultar();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            listarHistorico() {
                this.$refs.loading.showLoading();
                axios.get(`${this.urlApi}/v1/indice/listarHistorico/${this.selecteds[0].codIndice}`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.historico = response.data;
                    this.$refs['modal-historico'].show();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            limparFiltros() {
                this.filtros = {
                    filtrarDescricao: null,
                    descricao: null,
                    tipos: [],
                    filtrarAtualizacao: null,
                    atualizacao: null,
                    filtrarUsuario: null,
                    usuario: null,
                    cumulatividade: null,
                    situacao: null
                };

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            const msgDevedor = this.$store.getters.getMsgCrud;
            if(msgDevedor) {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: msgDevedor}]});
                this.$store.commit("setMsgCrud", null)
            }

            this.listarTipoIndice();
            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
